"use client";

import Script from "next/script";
import { ADSENSE_CLIENT } from "@/lib/adsense";
import { ADSENSE_READY_EVENT, LIVE_ADS_ENABLED } from "@/lib/adsense-runtime";

export default function AdSenseScript() {
  if (!LIVE_ADS_ENABLED) return null;
  return <Script
    id="apnilist-adsense"
    src={`https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CLIENT}`}
    strategy="afterInteractive"
    crossOrigin="anonymous"
    onReady={() => {
      window.apnilistAdsenseReady = true;
      window.dispatchEvent(new Event(ADSENSE_READY_EVENT));
    }}
  />;
}
